import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubmissions } from '../SubmissionsContext';

function IcoCamera({ c }) {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>;
}
function IcoStar({ c }) {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
}
function IcoShare({ c }) {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>;
}
function IcoCalendar({ c }) {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
}

const STAT_CARDS = [
  { key: 'total',    Icon: IcoCamera,   color: '#DB3267', bg: 'linear-gradient(145deg,#fce8ef,#fff)',  border: 'rgba(219,50,103,0.12)',  label: 'Submitted',     to: '/review' },
  { key: 'magic',    Icon: IcoStar,     color: '#f57f17', bg: 'linear-gradient(145deg,#fff8e1,#fff)',  border: 'rgba(245,127,23,0.12)', label: 'Magic Moments', to: '/feed' },
  { key: 'approved', Icon: IcoShare,    color: '#2e7d32', bg: 'linear-gradient(145deg,#e8f5e9,#fff)', border: 'rgba(46,125,50,0.12)',  label: 'Shared',        to: '/feed' },
  { key: 'days',     Icon: IcoCalendar, color: '#1565c0', bg: 'linear-gradient(145deg,#e3f2fd,#fff)', border: 'rgba(21,101,192,0.12)', label: 'Days Left' },
];

const AVATAR_COLOURS = [
  { bg: 'linear-gradient(135deg,#ffd54f,#ff8f00)', color: '#5d3d00' },
  { bg: 'linear-gradient(135deg,#cfd8dc,#90a4ae)', color: '#37474f' },
  { bg: 'linear-gradient(135deg,#ffab91,#bf360c)', color: '#fff' },
];

const s = {
  page: { padding: '20px 16px 24px', maxWidth: '540px', margin: '0 auto' },
  heading: { fontSize: '24px', fontWeight: '800', color: '#1a1a2e', marginBottom: '3px', letterSpacing: '-0.3px' },
  sub: { fontSize: '13px', color: '#aaa', fontWeight: '500', marginBottom: '24px' },

  winnerCard: {
    background: 'linear-gradient(135deg,#DB3267 0%,#9b1f4a 100%)',
    borderRadius: '18px', padding: '22px 20px', marginBottom: '24px', color: '#fff',
    boxShadow: '0 6px 24px rgba(219,50,103,0.30)', position: 'relative', overflow: 'hidden',
  },
  winnerLabel: { fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.8px', opacity: 0.75, marginBottom: '8px' },
  winnerName: { fontSize: '20px', fontWeight: '800', marginBottom: '6px', lineHeight: 1.3 },
  winnerCaption: { fontSize: '13px', opacity: 0.88, lineHeight: '1.6', marginBottom: '8px' },
  winnerBy: { fontSize: '12px', opacity: 0.65, fontWeight: '500' },
  socialLink: {
    display: 'inline-block', marginTop: '12px', background: 'rgba(255,255,255,0.18)',
    border: '1px solid rgba(255,255,255,0.35)', color: '#fff', borderRadius: '10px',
    padding: '7px 14px', fontSize: '12px', fontWeight: '600', textDecoration: 'none',
  },

  statsGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '24px' },
  statCard: {
    borderRadius: '16px', padding: '20px 16px',
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
  },
  statIconWrap: { width: '48px', height: '48px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  statValue: { fontSize: '34px', fontWeight: '800', lineHeight: 1, letterSpacing: '-0.5px' },
  statLabel: { fontSize: '10px', fontWeight: '700', color: '#bbb', textTransform: 'uppercase', letterSpacing: '0.5px', textAlign: 'center' },

  sectionRow: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' },
  sectionLabel: { fontSize: '11px', fontWeight: '800', color: '#DB3267', textTransform: 'uppercase', letterSpacing: '0.8px', whiteSpace: 'nowrap' },
  sectionLine: { flex: 1, height: '1px', background: 'linear-gradient(to right,rgba(219,50,103,0.18),transparent)' },

  shiftCard: { background: '#fff', borderRadius: '16px', padding: '20px 18px', marginBottom: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' },
  shiftRow: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' },
  shiftRowLast: { display: 'flex', alignItems: 'center', gap: '12px' },
  shiftLabel: { fontSize: '13px', fontWeight: '600', width: '76px', color: '#444', display: 'flex', alignItems: 'center', gap: '5px' },
  barTrack: { flex: 1, height: '10px', background: '#f0eef4', borderRadius: '10px', overflow: 'hidden' },
  barFillDay: { height: '100%', borderRadius: '10px', background: 'linear-gradient(90deg,#DB3267,#f06292)', transition: 'width 0.6s ease' },
  barFillNight: { height: '100%', borderRadius: '10px', background: 'linear-gradient(90deg,#1c3d6e,#3d5a99)', transition: 'width 0.6s ease' },
  barCount: { fontSize: '14px', fontWeight: '800', color: '#333', width: '22px', textAlign: 'right' },

  leaderCard: { background: '#fff', borderRadius: '16px', padding: '18px 18px 8px', marginBottom: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' },
  leaderRow: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' },
  leaderAvatar: { width: '38px', height: '38px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', fontWeight: '800', flexShrink: 0 },
  leaderName: { flex: 1, fontSize: '14px', fontWeight: '600', color: '#1a1a2e' },
  leaderCount: { fontSize: '13px', fontWeight: '700', color: '#DB3267' },

  adminSection: { marginTop: '8px' },
  selectCard: {
    background: '#fff', borderRadius: '12px', padding: '14px 16px', marginBottom: '8px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.05)', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    cursor: 'pointer', border: '1.5px solid transparent',
  },
  selectCardActive: { border: '1.5px solid #DB3267', background: '#fdf0f4' },
  selectName: { fontSize: '14px', fontWeight: '600', color: '#1a1a2e' },
  selectMeta: { fontSize: '12px', color: '#aaa', marginTop: '2px' },
  checkCircle: { width: '24px', height: '24px', borderRadius: '50%', background: '#DB3267', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '13px', fontWeight: '700', flexShrink: 0 },
  markWinnerBtn: {
    width: '100%', padding: '15px',
    background: 'linear-gradient(135deg,#DB3267,#b8254f)',
    color: '#fff', borderRadius: '12px', fontWeight: '700', fontSize: '15px', marginTop: '14px',
    boxShadow: '0 4px 14px rgba(219,50,103,0.28)', border: 'none',
  },
  markWinnerBtnDisabled: { background: '#e8e8ee', color: '#ccc', boxShadow: 'none', cursor: 'not-allowed' },
  socialInputWrap: { marginTop: '16px' },
  socialLabel: { fontSize: '11px', fontWeight: '700', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px', display: 'block' },
  socialInput: { width: '100%', padding: '11px 14px', border: '1.5px solid #e8e8ee', borderRadius: '10px', fontSize: '14px', color: '#1a1a2e' },
};

function SectionLabel({ children }) {
  return (
    <div style={s.sectionRow}>
      <span style={s.sectionLabel}>{children}</span>
      <div style={s.sectionLine} />
    </div>
  );
}

function daysLeft() {
  const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return end.getDate() - now.getDate();
}

export default function ThisMonth({ user }) {
  const { submissions, winner, markWinner } = useSubmissions();
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState(winner || null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [socialLink, setSocialLink] = useState('');

  const thisMonth = new Date().toISOString().slice(0, 7);
  const monthSubs = submissions.filter(s => s.month === thisMonth || s.submittedAt.startsWith('2026-03'));
  const approved = monthSubs.filter(s => s.status === 'approved');
  const magic = monthSubs.filter(s => s.category === 'Magic Moment').length;
  const day = monthSubs.filter(s => s.shift === 'Day').length;
  const night = monthSubs.filter(s => s.shift === 'Night').length;
  const total = monthSubs.length;
  const maxShift = Math.max(day, night, 1);

  const counts = {};
  monthSubs.forEach(s => { counts[s.submittedBy] = (counts[s.submittedBy] || 0) + 1; });
  const leaderboard = Object.entries(counts).sort((a, b) => b[1] - a[1]).slice(0, 3);

  const winnerSub = winner ? submissions.find(s => s.id === winner) : null;
  const statValues = { total, magic, approved: approved.length, days: daysLeft() };

  function handleMarkWinner() {
    if (selectedId) markWinner(selectedId);
  }

  return (
    <div style={s.page}>
      <h1 style={s.heading}>This Month</h1>
      <p style={s.sub}>March 2026 · {daysLeft()} days remaining</p>

      {winnerSub && (
        <div style={s.winnerCard}>
          <div style={{ position: 'absolute', top: '-30px', right: '-30px', width: '120px', height: '120px', borderRadius: '50%', background: 'rgba(255,255,255,0.06)', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', top: '40px', right: '-10px', width: '70px', height: '70px', borderRadius: '50%', background: 'rgba(255,255,255,0.04)', pointerEvents: 'none' }} />
          <div style={s.winnerLabel}>🏆 This Month's Winner</div>
          <div style={s.winnerName}>{winnerSub.about}</div>
          <div style={s.winnerCaption}>{winnerSub.caption.slice(0, 140)}{winnerSub.caption.length > 140 ? '...' : ''}</div>
          <div style={s.winnerBy}>Submitted by {winnerSub.submittedBy}</div>
          {socialLink && (
            <a href={socialLink} target="_blank" rel="noreferrer" style={s.socialLink}>See our social post →</a>
          )}
        </div>
      )}

      {/* Stats */}
      <div style={s.statsGrid}>
        {STAT_CARDS.map(({ key, Icon, color, bg, border, label, to }) => (
          <div
            key={key}
            onClick={to ? () => navigate(to) : undefined}
            onMouseEnter={to ? () => setHoveredCard(key) : undefined}
            onMouseLeave={to ? () => setHoveredCard(null) : undefined}
            style={{
              ...s.statCard,
              background: bg,
              border: hoveredCard === key ? `1.5px solid ${color}` : `1px solid ${border}`,
              cursor: to ? 'pointer' : 'default',
              transform: hoveredCard === key ? 'translateY(-2px)' : 'none',
              boxShadow: hoveredCard === key ? `0 6px 20px ${color}22` : '0 2px 12px rgba(0,0,0,0.05)',
              transition: 'transform 0.15s ease, box-shadow 0.15s ease, border 0.15s ease',
            }}
          >
            <div style={{ ...s.statIconWrap, background: `${color}15` }}>
              <Icon c={color} />
            </div>
            <div style={{ ...s.statValue, color }}>{statValues[key]}</div>
            <div style={s.statLabel}>{label}{to && ' →'}</div>
          </div>
        ))}
      </div>

      {/* Day vs Night */}
      <SectionLabel>Day vs Night</SectionLabel>
      <div style={s.shiftCard}>
        <div style={s.shiftRow}>
          <div style={s.shiftLabel}><span>☀️</span> Day</div>
          <div style={s.barTrack}>
            <div style={{ ...s.barFillDay, width: `${(day / maxShift) * 100}%` }} />
          </div>
          <div style={s.barCount}>{day}</div>
        </div>
        <div style={s.shiftRowLast}>
          <div style={s.shiftLabel}><span>🌙</span> Night</div>
          <div style={s.barTrack}>
            <div style={{ ...s.barFillNight, width: `${(night / maxShift) * 100}%` }} />
          </div>
          <div style={s.barCount}>{night}</div>
        </div>
      </div>

      {/* Leaderboard */}
      {leaderboard.length > 0 && (
        <>
          <SectionLabel>Top Submitters</SectionLabel>
          <div style={s.leaderCard}>
            {leaderboard.map(([name, count], i) => {
              const av = AVATAR_COLOURS[i] || { bg: 'linear-gradient(135deg,#e0e0e0,#bdbdbd)', color: '#555' };
              return (
                <div key={name} style={s.leaderRow}>
                  <div style={{ ...s.leaderAvatar, background: av.bg, color: av.color }}>
                    {name.charAt(0)}
                  </div>
                  <div style={s.leaderName}>{name}</div>
                  <div style={s.leaderCount}>{count} moment{count !== 1 ? 's' : ''}</div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* Admin — pick winner */}
      {user.role === 'admin' && (
        <div style={s.adminSection}>
          <SectionLabel>Pick This Month's Winner</SectionLabel>
          {approved.map(sub => (
            <div
              key={sub.id}
              style={{ ...s.selectCard, ...(selectedId === sub.id ? s.selectCardActive : {}) }}
              onClick={() => setSelectedId(sub.id)}
            >
              <div>
                <div style={s.selectName}>{sub.about}</div>
                <div style={s.selectMeta}>{sub.submittedBy} · {sub.category}</div>
              </div>
              {selectedId === sub.id && <div style={s.checkCircle}>✓</div>}
            </div>
          ))}

          {selectedId && !winner && (
            <div style={s.socialInputWrap}>
              <label style={s.socialLabel}>Social media post link (optional)</label>
              <input
                style={s.socialInput}
                type="url"
                placeholder="https://facebook.com/..."
                value={socialLink}
                onChange={e => setSocialLink(e.target.value)}
              />
            </div>
          )}

          <button
            style={{ ...s.markWinnerBtn, ...(!selectedId || winner ? s.markWinnerBtnDisabled : {}) }}
            onClick={handleMarkWinner}
            disabled={!selectedId || !!winner}
          >
            {winner ? '🏆 Winner announced!' : 'Announce Winner'}
          </button>
        </div>
      )}
    </div>
  );
}
